import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { withRouter } from 'react-router-dom';
import OnboardingSmsModalSC from './onboarding-sms-modal.styled';
import { HeadingTwo, BodyText, SmallText } from '../../typography';
import dlt from '../../../utils/default-lang';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Button from '../../ui/button';
import ReactCodeInput from 'react-code-input';

const _OnboardingSmsModal = ({
  additionalData,
  additionalInfo,
  sendInvestorOnboardingStep,
  getInvestorOnboardingStep,
  sendSms,
  phoneNumber,
  onClose,
}) => {
  const codeRef = useRef(undefined);
  const [smsValue, setSmsValue] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isBadSms, setIsBadSms] = useState(false);

  useEffect(() => {
    if (smsValue.length < 4) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [smsValue]);

  const clearInputs = () => {
    codeRef.current.state.input[0] = '';
    codeRef.current.state.input[1] = '';
    codeRef.current.state.input[2] = '';
    codeRef.current.state.input[3] = '';
  };

  const sendSmsAgain = () => {
    if (phoneNumber !== null) {
      sendSms({ phone: phoneNumber });
    } else {
      sendSms();
    }
  };

  const sendValue = () => {
    const dataToSend = {
      sms_code: smsValue,
      ...additionalData,
    };

    const onSuccess = () => {
      setIsDisabled(false);
      getInvestorOnboardingStep();
      onClose();
    };

    const onBadSmsCode = () => {
      setIsDisabled(false);
      setIsBadSms(true);
      setSmsValue('');
      clearInputs();

      setTimeout(() => {
        setIsBadSms(false);
      }, 3500);
    };

    const sendModalData = async () => {
      setIsDisabled(true);
      await sendInvestorOnboardingStep({
        data: dataToSend,
        onSuccess,
        onBadSmsCode,
        onError: () => {
          setIsDisabled(false);
        },
      });
    };

    sendModalData();
  };
  return (
    <OnboardingSmsModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedMessage
            id="onboarding_sms_modal_headline"
            defaultMessage={dlt['onboarding_sms_modal_headline']}
          />
        </HeadingTwo>
        <BodyText>
          <FormattedHTMLMessage
            id="onboarding_sms_modal_subtext"
            defaultMessage={dlt['onboarding_sms_modal_subtext']}
          />
        </BodyText>
      </div>
      <div className="sms-input-wrap">
        <ReactCodeInput
          type="number"
          ref={codeRef}
          fields={4}
          className={isBadSms ? 'sms-code bad-sms' : 'sms-code'}
          onChange={(val) => setSmsValue(val)}
          value={smsValue}
        />

        {isBadSms ? (
          <BodyText className="red bolder">
            <FormattedHTMLMessage
              id="onboarding_sms_modal_bad_sms"
              defaultMessage={dlt['onboarding_sms_modal_bad_sms']}
            />
          </BodyText>
        ) : null}

        <Button type="PRIMARY" onClick={() => sendValue()} disabled={isDisabled}>
          <FormattedMessage
            id="onboarding_sms_modal_btn"
            defaultMessage={dlt['onboarding_sms_modal_btn']}
          />
        </Button>
      </div>

      {additionalInfo !== '' ? (
        <div className="bottom-resend-wrap">
          <SmallText className="black-transparent align-justify">
            <FormattedHTMLMessage id={additionalInfo} defaultMessage={dlt[`${additionalInfo}`]} />
          </SmallText>
        </div>
      ) : null}

      <div className="bottom-resend-wrap">
        <SmallText className="black-transparent">
          <FormattedMessage
            id="onboarding_sms_modal_not_coming"
            defaultMessage={dlt['onboarding_sms_modal_not_coming']}
          />
        </SmallText>
        <Button type="LINK" onClick={() => sendSmsAgain()}>
          <FormattedHTMLMessage
            id="onboarding_sms_modal_resend_btn"
            defaultMessage={dlt['onboarding_sms_modal_resend_btn']}
          />
        </Button>
      </div>
    </OnboardingSmsModalSC>
  );
};

const mapStateToProps = (state) => {
  return {
    onboardingStep: state.onboarding.step,
    personalNumber: state.user.wm_number,
    phoneNumber: state.user.phone_number,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getInvestorOnboardingStep: ActionCreators.getInvestorOnboardingStep,
      sendInvestorOnboardingStep: ActionCreators.sendInvestorOnboardingStep,
      sendSms: ActionCreators.sendSms,
    },
    dispatch
  );
};

const OnboardingSmsModal = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_OnboardingSmsModal)
);

export default OnboardingSmsModal;
